import { all } from "redux-saga/effects";
import {
  binlocationAddWatcher,
  inventoryCreateWatcher,
  stockTransferCreateWatcher,
  stockTransferEditWatcher,
  stockTransferTableWatcher,
  stockTransferViewWatcher,
  stockTransferbatchWatcher,
  voidStockTransferItemWatcher,
  voidStockTransferWatcher,
  warehouseListWatcher,
  warehouseGetIdWatcher,
  warehouseListWithCapacityWatcher,
  warehouseBinListWatcher,
  warehouseBinGenerateWatcher,
  warehouseBinAddWatcher,
  warehouseBinUpdateWatcher,
  warehouseBinDeleteWatcher,
  warehouseBinDefaultItemsAddWatcher,
  warehouseBinDefaultItemsListWatcher,
  warehouseBinSetDefaultWatcher,
} from "../inventory-saga";

export default function* inventoryRootSaga() {
  yield all([
    inventoryCreateWatcher(),
    binlocationAddWatcher(),
    warehouseListWatcher(),
    warehouseGetIdWatcher(),
    warehouseListWithCapacityWatcher(),
    warehouseBinListWatcher(),
    warehouseBinGenerateWatcher(),
    warehouseBinAddWatcher(),
    warehouseBinUpdateWatcher(),
    warehouseBinDeleteWatcher(),
    warehouseBinDefaultItemsAddWatcher(),
    warehouseBinDefaultItemsListWatcher(),
    warehouseBinSetDefaultWatcher(),
    stockTransferCreateWatcher(),
    stockTransferEditWatcher(),
    stockTransferTableWatcher(),
    stockTransferViewWatcher(),
    stockTransferbatchWatcher(),
    voidStockTransferWatcher(),
    voidStockTransferItemWatcher(),
  ]);
}
